import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import styled from "styled-components";
import WithAuth from "../../components/partials/withAuth";
import { SVGs } from "../../assets/svg/SVGs";
import { getEstateID, MssgContainer } from "../../components/partials/utils";
import { useCurrentLocation } from "../../utils/useLocation";

const SchedulesComp = () => {
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [data, setData] = useState({});
  const [editSchedule, setEditSchedule] = useState({});
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  const fetchSchedules = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/schedules?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setSchedules(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  useEffect(() => {
    fetchSchedules();
  }, []);

  const editSchedules = (id) => {
    const item = schedules.find((element) => element.id == id);
    setEditSchedule(item);
    setEdit(true);
    setOpenModal(true);
  };

  const addSchedule = (schedule) => {
    setLoading(true);
    if (edit) {
      const api = `${HOST_URL()}patrols/manage/schedules/${editSchedule?.id}/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions(
        "patch",
        JSON.stringify(schedule),
        true,
      );
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Schedule Updated successfully" });
            fetchSchedules();
            // const edited_data = schedules.map((item) => {
            //   if (item.id == editSchedule.id) {
            //     return data;
            //   }
            //   return item;
            // });
            // setSchedules(edited_data);
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Updating Schedule",
              error: true,
            });
          }
        })
        .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }))
        .finally(() => {
          setLoading(false);
        });
    } else {
      const api = `${HOST_URL()}patrols/manage/schedules/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions("post", JSON.stringify(schedule), true);
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Schedule Created successfully" });
            // setSchedules([...schedules, data]);
            fetchSchedules();
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Creating Schedule",
              error: true,
            });
          }
        })
        .catch((err) => {
          setMssg({ ...mssg, mssg: err.name, error: true });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteSchedule = (id) => {
    setDeleting(true);
    const api = `${HOST_URL()}patrols/manage/schedules/${id}/?estate_id=${getEstateID()}`;
    const requestOptions = reqOptions("delete", null, true);
    fetch(api, requestOptions)
      .then((res) => {
        if (res?.ok) {
          fetchSchedules();
          setMssg({
            ...mssg,
            mssg: "Schedule deleted successfully",
            error: true,
          });
        }
      })
      .catch((err) => {
        setMssg({ ...mssg, mssg: err.message, error: true });
      })
      .finally(() => setDeleting(false));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditSchedule({});
    setEdit(false);
  };

  return (
    <div style={{ minHeight: "50vh" }}>
      {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}
      <h1 style={{ textAlign: "center" }}>Schedules</h1>
      <div>
        <button className="important-btn" onClick={() => setOpenModal(true)}>
          Create Schedule
        </button>
      </div>
      <ScheduleGrid>
        <div className="Utility_table">
          {schedules.length ? (
            schedules?.map((schedule, index) => (
              <Schedule
                key={index}
                deleteSchedule={deleteSchedule}
                deleting={deleting}
                fetchSchedules={fetchSchedules}
                schedules={schedules}
                schedule={schedule}
                editSchedules={editSchedules}
              />
            ))
          ) : (
            <p>
              No schedule created at the moment.{" "}
              <a
                onClick={() => setOpenModal(true)}
                style={{
                  cursor: "pointer",
                  color: "#2D4BF3",
                  fontWeight: "bolder",
                }}
              >
                Create one
              </a>
            </p>
          )}
        </div>
      </ScheduleGrid>
      <Modal
        mssg={mssg}
        loading={loading}
        schedules={schedules}
        open={openModal}
        onClose={handleCloseModal}
        addSchedule={addSchedule}
        edit_data={editSchedule}
        edit={edit}
      />
    </div>
  );
};

export default SchedulesComp;

const Schedule = ({
  schedules,
  schedule,
  editSchedules,
  fetchSchedules,
  deleteSchedule,
  deleting,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [report, setReports] = useState([]);
  const [data, setData] = useState({});
  const [patrolArea, setPatrolArea] = useState({});

  const fetchPatrolArea = (schedulePatrolArea) => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/areas/${schedulePatrolArea}/?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setPatrolArea(data);
      })
      .catch((err) => {
        // setMssg({ ...mssg, mssg: err.message, error: true })
      });
  };

  useEffect(() => {
    if (schedule?.patrol_area) fetchPatrolArea(schedule?.patrol_area);
  }, [schedule?.patrol_area]);

  const addReport = (report) => {
    setReports((prev) => [...prev, report]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="utils">
        <div className="util-payment">
          <div className="name_tag">
            <h4>{schedule.name}</h4>
            {/* <button>{schedule.name}</button> */}
          </div>

          <div className="util-acct">
            <p>
              Patrol Area: <b>{patrolArea?.name || ""}</b>
            </p>
            <p>
              Days of week: <b>{schedule.days_of_week || "-"}</b>
            </p>
            <p>
              Start time: <b>{schedule.start_time || "-"}</b>
            </p>
            <p>
              End time: <b>{schedule.end_time || "-"}</b>
            </p>
            <div className="price">
              <p>{new Date(schedule.timestamp).toLocaleString()}</p>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <span
              className="edit-btn util-btn"
              onClick={() => editSchedules(schedule.id)}
            >
              Edit
            </span>
            <span
              aria-disabled={deleting}
              className="del-btn util-btn"
              onClick={() => deleteSchedule(schedule.id)}
            >
              {/* {deleting ? "Deleting..." : "Delete"} */}
              Delete
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const Modal = ({
  mssg,
  loading,
  open,
  onClose: passedClose,
  addSchedule,
  edit_data,
  edit,
  schedules,
}) => {
  const default_schedule = {
    patrol_area: edit_data?.patrol_area || "",
    days_of_week: edit_data?.days_of_week || "",
    start_time: edit_data?.start_time || "",
    end_time: edit_data?.end_time || "",
    assigned_estate_user: edit_data?.assigned_estate_user || null,
  };

  const [schedule, setSchedule] = useState(default_schedule);
  const [locationChoice, setLocationChoice] = useState(null);
  const { loading: locationLoading, getLocation } = useCurrentLocation();
  const [patrolAreas, setPatrolAreas] = useState([]);
  const [estateUsers, setEstateUsers] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);

  useEffect(() => {
    if (edit_data) {
      setSchedule({
        patrol_area: edit_data?.patrol_area,
        days_of_week: edit_data?.days_of_week,
        start_time: edit_data?.start_time,
        end_time: edit_data?.end_time,
        assigned_estate_user: edit_data?.assigned_estate_user,
      });
    }
  }, [edit_data]);

  const fetchPatrolAreas = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/areas?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setPatrolAreas(data.results);
      })
      .catch((err) => {
        // setMssg({ ...mssg, mssg: err.message, error: true })
      });
  };

  const fetchEstateUsers = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_users/admin_list/?estate_id=${getEstateID()}&user_type=SECURITY&page=1&limit=20`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setEstateUsers(data.results);
      })
      .catch((err) => {
        // setMssg({ ...mssg, mssg: err.message, error: true })
      });
  };

  useEffect(() => {
    fetchPatrolAreas();
    fetchEstateUsers();
  }, []);

  useEffect(() => {
    setSchedule({ ...schedule, days_of_week: selectedDays.join(",") });
  }, [selectedDays]);

  if (!open) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchedule({ ...schedule, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addSchedule(schedule);
    setSchedule(default_schedule);
    onClose(false);
  };
  const isValid =
    schedule?.patrol_area &&
    schedule?.days_of_week &&
    schedule?.start_time &&
    schedule?.end_time &&
    schedule?.assigned_estate_user;

  const onClose = () => {
    passedClose();
    setSchedule(default_schedule);
  };

  const days = [
    "Monday",
    "Tuesday",
    "Wednessday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="new_estates_form fade-in-bck">
          <div className="form-group">
            <div className="create_est ">
              <div className="form_txt">
                <h3>{edit ? "Edit" : "Add a"} schedule</h3>
              </div>
              <p>Days of the week</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  rowGap: "10px",
                  flexWrap: "wrap",
                  width: "100%",
                }}
              >
                {days?.map((day, i) => {
                  const dayToUse = i + 1;
                  const isSelected = selectedDays?.includes(dayToUse);

                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (selectedDays?.includes(dayToUse)) {
                          setSelectedDays((prev) =>
                            prev.filter((day) => day !== dayToUse),
                          );
                        } else {
                          setSelectedDays((prev) => [...prev, dayToUse]);
                        }
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          border: "1px solid",
                          borderColor: !isSelected ? "#ccc" : "#2d4bf3",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: "auto",
                          marginLeft: "auto",
                        }}
                      >
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            background: !isSelected ? "#ccc" : "#2d4bf3",
                          }}
                        />
                      </div>
                      <p>{day}</p>
                    </div>
                  );
                })}
              </div>
              {/* <input
                type="text"
                value={schedule.days_of_week}
                name="days_of_week"
                placeholder="Days of the week"
                onChange={handleChange}
              /> */}
              <p>Select a patrol area</p>
              <select
                placeholder="Patrol Area"
                value={schedule.patrol_area}
                name="patrol_area"
                onChange={handleChange}
                className="form-control"
                style={{ marginBottom: "16px" }}
              >
                <option value={""} key={""}>
                  Select Patrol Area
                </option>
                {patrolAreas?.map((patrolArea) => (
                  <option value={patrolArea.id} key={patrolArea.id}>
                    {patrolArea.name}
                  </option>
                ))}
              </select>

              <p>Start Time</p>
              <input
                type="time"
                placeholder="Start Time"
                value={schedule.start_time}
                name="start_time"
                onChange={handleChange}
              />

              <p>End Time</p>
              <input
                type="time"
                placeholder="End Time"
                value={schedule.end_time}
                name="end_time"
                onChange={handleChange}
              />

              <p>Select an security user</p>
              <select
                placeholder="Assigned User"
                value={schedule.assigned_estate_user}
                name="assigned_estate_user"
                onChange={handleChange}
                className="form-control"
                style={{ marginBottom: "16px" }}
              >
                <option value={""} key={""}>
                  Select Assigned User
                </option>
                {estateUsers?.map((estateUser) => (
                  <option value={estateUser.id} key={estateUser.id}>
                    {estateUser?.user?.first_name} {estateUser?.user?.last_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {mssg?.mssg && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
              {mssg?.mssg}
            </p>
          )}
          <button
            style={{ marginTop: 40 }}
            disabled={!isValid || loading}
            className="btn btn-success btn-block"
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : `${edit ? "Edit" : "Add"} schedule`}
          </button>
        </div>
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }
  @media (max-width: 420px) {
    .search_set,
    button {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (min-width: 760px) {
    display: flex;
    justify-content: space-between;
    .search_set {
      width: 220px;
    }
    .outlined {
      width: 180px !important;
    }
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin: 0 10px;
        width: 135px;
      }
      button {
        margin-top: 0;
        height: 45px;
        margin-left: 10px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;
      padding: 5px 20px;
      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
const ScheduleGrid = styled.div`
  .team-members {
    margin-top: 40px;
  }

  .Utility_table {
    display: flex;
    flex-wrap: wrap;
  }
  .btn {
    display: flex;
  }
  .utils {
    margin-bottom: 10px;
    margin: 10px;
    padding: 16px;
    width: 100%;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    .name_tag {
      h4 {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
      button {
        margin: 0;
        font-weight: 400;
        padding: 2px 8px;

        font-size: 14px;
        margin-top: 10px;
        background: #f2f6ff;
        border: 1px solid #2d4bf3;
        border-radius: 5px;
      }
    }
  }

  .reason {
    width: 128px;
    height: 24px;
    background: #f2f6ff;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    padding: 4px 8px;
  }
  .price {
    margin-top: 10px;
  }
  .util-acct {
    margin-top: 10px;
  }

  .util-btn {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .del-btn {
    color: #ff6969;
  }
  .edit-btn {
    color: #2d4bf3;
  }
  @media (min-width: 540px) {
    .utils {
      width: 48%;
    }
  }
  @media (min-width: 1024px) {
    .utils {
      width: 33%;
    }
  }
  @media (min-width: 1200px) {
    .utils {
      width: 24%;
    }
  }
`;
